var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Breadcrumb',[_c('BreadcrumbItem',{attrs:{"to":"/"}},[_vm._v("首页")]),_c('BreadcrumbItem',{attrs:{"to":"/user/userInfo"}},[_vm._v("个人中心")]),_c('BreadcrumbItem',[_vm._v("确认订单")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }